const ENDPOINT = "https://lcicorporativo.co/sistema-formulario/public/api/"

export async function Guardar(data) {
    return fetch(`${ENDPOINT}saveinfo`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'post',
        body: JSON.stringify(data)
    }).then(res => res.json()).then(response => {
        return response;
    });
}